import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { CalendarTab } from '../../profile/calendarTab';

const CalendarStep = ({ provider, setProvider, onNext, onBack, onSkip }) => {
  return (
    <Box sx={{ maxWidth: '905px', margin: '0 auto' }}>
      <Typography variant="h4" sx={{ marginBottom: '20px' }}>
        Calendar
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ marginBottom: '24px' }}>
        Add your service providers and set their working hours. You can change this anytime from your profile.
      </Typography>

      {/* Calendar editor */}
      <Box sx={{ marginBottom: '30px' }}>
        <CalendarTab provider={provider} onProviderUpdate={setProvider} />
      </Box>

      {/* Bottom navigation */}
      <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '40px' }}>
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>
        <Box sx={{ display: 'flex', gap: '10px' }}>
          <Button variant="text" onClick={onSkip}>
            Skip For Now
          </Button>
          <Button variant="contained" onClick={onNext}>
            Save & Continue
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

CalendarStep.propTypes = {
  provider: PropTypes.object.isRequired,
  setProvider: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired
};

export default CalendarStep;
